import React from "react";

import {
  Accessibility,
  Contrast,
  ZoomIn,
  ZoomOut,
  RotateCcw,
  BookOpen,
} from "lucide-react";

import { useAccessibility } from "../../../main/hooks/accessibility/use-accessibility";

import "./accessibility-toolbar.css";

export const AccessibilityToolbar: React.FC = () => {
  const {
    increaseFont,
    decreaseFont,
    resetFont,
    toggleHighContrast,
    toggleReaderMode,
    state,
  } = useAccessibility();

  return (
    <div
      role="toolbar"
      aria-label="Ferramentas de acessibilidade"
      className="accessibility-toolbar"
    >
      <button
        onClick={toggleHighContrast}
        aria-label="Ativar alto contraste"
        title="Alto contraste"
      >
         ◐ 
      </button>

      <button
        onClick={increaseFont}
        aria-label="Aumentar fonte"
        title="Aumentar fonte"
      >
        A+ 
      </button>

      <button
        onClick={decreaseFont}
        aria-label="Diminuir fonte"
        title="Diminuir fonte"
      >
        A- 
      </button>

      <button
        onClick={resetFont}
        aria-label="Resetar fonte"
        title="Resetar fonte"
      >
        A=
      </button>

      <button
        onClick={toggleReaderMode}
        aria-label="Modo leitor"
        title="Modo leitor"
      >
        <BookOpen />
      </button>

      <span aria-live="polite">
        Fonte: {state.fontScale.toFixed(1)}x
      </span>
    </div>
  );
};